<!-- 首页点击跳转到服务大厅页面 -->
<template>
  <div class="service">
    <div class="serviceDiv clearfix">
      <!--   <div class="gradeSelect" @click="gotGradeSelect">
        <div class="gradeSelectImgDiv">
          <img src="../../assets/image/btn_dangan_nor.png" alt="成绩查询" class="gradeSelectImg" />
          <div class="gradeSelectName">成绩档案查询</div>
        </div>
      </div> -->
      <div class="backSchool one" @click="gotoAppointment">
        <div class="backSchoolImgDiv">
          <img
            src="../../assets/image/btn_xunren_nor.png"
            alt="返校预约"
            class="backSchoolImg"
          />
          <div class="backSchoolName">集体返校预约</div>
        </div>
      </div>
      <div class="other" @click="gotoTips">
        <div class="otherImgDiv">
          <img
            src="../../assets/image/btn_zhinan_nor.png"
            alt="其他"
            class="otherImg"
          />
          <div class="otherName">办事指南</div>
        </div>
      </div>
      <!--  <div class="foundPerson" @click="gotoFoundPerson">
        <div class="foundPersonImgDiv">
          <img src="../../assets/image/btn_xunren_nor.png" alt="寻人找人" class="foundPersonImg" />
          <div class="foundPersonName">寻人找人</div>
        </div>

      </div> -->
      <div class="telNote" @click="gotoMailList">
        <div class="telNoteImgDiv">
          <img
            src="../../assets/image/btn_tongxunlu_nor.png"
            alt="校友工作人员通讯录"
            class="telNoteImg"
          />
          <div class="telNoteName">校友工作人员通讯录</div>
        </div>
      </div>
      <div class="other" @click="gotoOther">
        <div class="otherImgDiv">
          <img
            src="../../assets/image/btn_qita_nor.png"
            alt="其他"
            class="otherImg"
          />
          <div class="otherName">其他</div>
        </div>
      </div>
    </div>
    <!-- 底部标签 -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      bottomCheck: "service",
      isReal: "",
    };
  },
  created() {
    this.isReal = localStorage.getItem("realStatus");
  },
  methods: {
    // 全屏点击事件
    /**
     * 判断是否实名
     * code: 411未填写身份证  400未完成实名认证
     * */
    async toRealName() {
      const res = await this.$http({
        url: "/xjcard/selectSm",
        method: "get",
        params: {
          user_id: localStorage.getItem("user_id"),
        },
      });
      const { code, msg } = res.data;
      if (code === "411") {
        this.$toast(msg);
        await this.$router.push("/idSucess");
        return false;
      }
      if (code === "400") {
        this.$toast(msg);
        await this.$router.push("/completeInfo?isReal=false");
        return false;
      }
      return true;
    },
    async gotoIndex() {
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${window.localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        return this.$router.push("/index");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    async gotoMine() {
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${window.localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        return this.$router.push("/mine");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    async gotoService() {
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${window.localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        return this.$router.push("/service");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    // 集体返校预约
    async gotoAppointment() {
      // return this.$router.push("/appointment");
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${window.localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        // return this.$router.push("/AppointmentCollective");
        return this.$router.push("/appointment");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    async gotGradeSelect() {
      if (!(await this.toRealName())) {
        return;
      }
      // return this.$router.push("/gradeSelect");
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${window.localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        return this.$router.push("/gradeSelect");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    async gotoFoundPerson() {
      return this.$router.push("/foundPerson");
      // if (!await this.toRealName()) {
      //   return
      // }
      //   // 走接口
      // const res = await this.$http({
      //   // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
      //   url: `/realNameAuthentication/isRealName?userId=${localStorage.getItem("user_id")}`,
      //   method: "POST",
      //   // data:data,
      // })
      // console.log(res);
      // if (res.data.code == 200) {
      //   return this.$router.push("/foundPerson");
      // } else {
      //   this.$toast("您没有实名认证，请进行实名认证")
      //   //  接受参数若果实名认证失败/未实名 跳实名页面
      //   this.$router.push("/completeInfo?isReal=false");
      // }
    },
    // 其他
    async gotoOther() {
      // return this.$router.push("/other");
      if (!(await this.toRealName())) {
        return;
      }
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${window.localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        return this.$router.push("/other");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    // 办事指南
    async gotoTips() {
      // return this.$router.push("/serviceTips");
      if (!(await this.toRealName())) {
        return;
      }
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        return this.$router.push("/serviceTips");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    // 校友工作人员通讯录
    async gotoMailList() {
      // return this.$router.push("/mailList");
      if (!(await this.toRealName())) {
        return;
      }
      // 走接口
      const res = await this.$http({
        // url: `/isRealName?userId=${localStorage.getItem("user_id")}`,
        url: `/realNameAuthentication/isRealName?userId=${window.localStorage.getItem(
          "user_id"
        )}`,
        method: "POST",
        // data:data,
      });
      console.log(res);
      if (res.data.code == 200) {
        return this.$router.push("/mailList");
      } else {
        this.$toast("您没有实名认证，请进行实名认证");
        //  接受参数若果实名认证失败/未实名 跳实名页面
        this.$router.push("/completeInfo?isReal=false");
      }
    },
    /* gotoSiginIn() {
      return this.$router.push("/siginIn");
    }, */
    gotoScenery() {
      window.location.href =
        "http://schoollegant.alumni-resource.com/index.html#/";
    },
  },
};
</script>
<style lang="less" scoped>
.service {
  position: relative;

  .serviceDiv {
    position: relative;
    left: 5%;
    width: 90%;

    .gradeSelect,
    .backSchool,
    .foundPerson,
    .telNote,
    .other {
      /* float: left;
      width: 20%;
      margin: 10px 2.5%; */
      position: relative;
      width: 100%;
      margin-bottom: 10px;

      .gradeSelectImgDiv,
      .backSchoolImgDiv,
      .foundPersonImgDiv,
      .telNoteImgDiv,
      .otherImgDiv {
        width: 100%;

        .gradeSelectImg,
        .backSchoolImg,
        .foundPersonImg,
        .telNoteImg,
        .otherImg {
          width: 100%;
        }
      }

      .gradeSelectName,
      .backSchoolName,
      .foundPersonName,
      .telNoteName,
      .otherName {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateY(-50%);
        font-weight: 400;
        font-size: 1.2rem;
        color: #ffffff;
      }
    }

    .one {
      margin-top: 20px;
    }
  }
}

.bottom {
  height: 80px;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/service/Service.vue